import React from 'react';
import Currency from "../../../config/Currency";
import Measure from "../../../config/Measure";
import Activity from "../../../helpers/Activity";
import CurrencyFormat from "react-currency-format";
import './FilterOption.css';

function FilterOption({category, searchQuery, parentFilter, filterOption, widths, marginRight, labelColor, backgroundColor, animate, onDelete, metadata}) {
    const defaultWidth = 200;

    const getLabel = () => {
        const type = parentFilter.type;
        switch (type) {
            case 'size':
                return getSizeLabel();
            case 'price':
                return getPriceLabel();
            default:
                return getNormalLabel();
        }
    };

    const getWidthByType = () => {
        const type = parentFilter.type;
        switch (type) {
            case 'size':
                return widths.size || defaultWidth;
            case 'price':
                return widths.price || defaultWidth;
            default:
                return widths.other || defaultWidth;
        }
    };

    const getMetricData = () => {
        const type = parentFilter.type;
        let metadata = {category_id: category.id, category_name: category.name, search_query: searchQuery || null, filter_id: parentFilter.id, option_id: filterOption.id, filter_label: parentFilter.label, option_label: filterOption.label};
        switch (type) {
            case 'size':
                metadata.value = filterOption.value;
                metadata.unit = filterOption.unit;
                return metadata;
            case 'price':
                metadata.start_value = filterOption.startValue;
                metadata.end_value = filterOption.endValue;
                metadata.currency = filterOption.currency;
                return metadata;
            default:
                return metadata;
        }
    };

    const getNormalLabel = () => {
        return (
            <React.Fragment>
                <div className='filter-option-others-title'>{parentFilter.label || 'Filtro'}</div>
                <div className='filter-option-others-option'>{filterOption.label || '?'}</div>
            </React.Fragment>
        )
    };

    const getPriceLabel = () => {
        const currencyFormat = Currency.CLP;
        return (
            <div className='filter-option-price'>
                <span>
                    <span className='filter-option-price-title'>Desde:</span>
                    <CurrencyFormat
                        prefix={currencyFormat.prefix}
                        suffix=''
                        thousandSeparator={currencyFormat.thousandsSeparator}
                        decimalSeparator={currencyFormat.decimalSeparator}
                        decimalScale={currencyFormat.decimalScale}
                        value={filterOption.startValue || 0}
                        displayType='text'
                    /> {filterOption.currency || ''}
                </span>
                <br/>
                <span>
                    <span className='filter-option-price-title'>Hasta:</span>
                    <CurrencyFormat
                        prefix={currencyFormat.prefix}
                        suffix=''
                        thousandSeparator={currencyFormat.thousandsSeparator}
                        decimalSeparator={currencyFormat.decimalSeparator}
                        decimalScale={currencyFormat.decimalScale}
                        value={filterOption.endValue || 0}
                        displayType='text'
                    /> {filterOption.currency || ''}
                </span>
            </div>
        );
    };

    const getSizeLabel = () => {
        const measureFormat = Measure.default;
        return (
            <div className='filter-option-size'>
                <span className='filter-option-size-title'>{filterOption.label || 'Filtro'}</span>
                <br/>
                <span className='filter-option-size-value'>
                    Hasta <CurrencyFormat
                        prefix={measureFormat.prefix}
                        suffix={` ${filterOption.unit}`}
                        thousandSeparator={measureFormat.thousandsSeparator}
                        decimalSeparator={measureFormat.decimalSeparator}
                        decimalScale={measureFormat.decimalScale}
                        value={filterOption.value || 0}
                        displayType='text'
                    />
                </span>
            </div>
        );
    };

    const handleDelete = () => {
        if (onDelete) {
            Activity.log(metadata, 'filter-option', filterOption.id, 'remove', true, getMetricData());
            onDelete(parentFilter.id, filterOption.id);
        }
    };

    const filterOptionStyle = () => {
        const width = getWidthByType();
        return {
            width: 'auto',
            maxWidth: width,
            marginRight: marginRight ? marginRight : 15,
            background: backgroundColor || '#005B80'
        };
    };

    const labelStyle = () => {
        return {
            color: labelColor || '#FFFFFF'
        };
    };

    const deleteButtonStyle = () => {
        return {
            background: 'transparent',
            color: labelColor || '#FFFFFF',
            borderColor: labelColor || '#FFFFFF'
        };
    };

    return (
        <div className={`filter-option ${animate ? 'animated' : 'no-animation'}`} style={filterOptionStyle()}>
            <div className='filter-option-label' style={labelStyle()}>{getLabel()}</div>
            <div className='filter-option-delete-button' onClick={handleDelete} style={deleteButtonStyle()}>
                <span className='filter-option-delete-button-icon'>x</span>
            </div>
        </div>
    );
}

export default FilterOption;